export type PersonioApiOpenPosition = {
  id: number;
  subcompany: string;
  office: string;
  department: string;
  recruitingCategory: string;
  name: string;
  jobDescriptions: {
    jobDescription: {
      name: string;
      value: string;
    }[];
  };
  employmentType: string;
  seniority: string;
  schedule: string;

  yearsOfExperience: string;
  keywords: string;
  occupation: string;
  occupationCategory: string;
  createdAt: string;
};

export type CreateApplicationAttachment = {
  file: File;
  category: string;
};

export type CreateJobApplicationDto = {
  jobPositionId: string;
  recruitingChannelId: string;
  firstName: string;
  lastName: string;
  gender?: string;
  location?: string;
  email: string;
  phone: string;
  message?: string;
  tags?: string[];
  availableFrom: string;
  dateOfBirth: string;
  salaryExpectation?: string;
  linkedInUrl?: string;
  attachments?: CreateApplicationAttachment[];
};

export enum PersonioRecruitingChannel {
  SocialAdsLandingPage = '1440165',
  SocialAdsWebsite = '1427530',
  Website = '133400',
}

export enum PersonioApplicationFileCategory {
  Cv = 'cv',
  CoverLetter = 'cover-letter',
  EmploymentReference = 'employment-reference',
  Certificate = 'certificate',
  WorkSample = 'work-sample',
  Other = 'other',
}
